import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { HydratedRouter } from "react-router/dom";
import { NonceContext } from "src/lib/nonce";
import { getClientsideQueryClient } from "src/lib/queryClient";

const LOGIN_SUCCESS_STORAGE_KEY = "sofa:loginSuccess";

// If this tab was redirected after login, broadcast to other tabs and clean up the URL
try {
  window.addEventListener("storage", (event) => {
    if (event.key === LOGIN_SUCCESS_STORAGE_KEY) {
      window.location.reload();
    }
  });

  const url = new URL(window.location.href);
  if (url.searchParams.has("loginSuccess")) {
    try {
      localStorage.setItem(LOGIN_SUCCESS_STORAGE_KEY, String(Date.now()));
    } catch {
      // noop
    }

    url.searchParams.delete("loginSuccess");
    const newSearch = url.searchParams.toString();
    const newUrl = `${url.pathname}${newSearch ? `?${newSearch}` : ""}${url.hash}`;
    window.history.replaceState({}, "", newUrl);
  }
} catch {
  // noop
}

const clientNonce =
  typeof document !== "undefined" ?
    (document.querySelector("script[nonce]") as HTMLScriptElement | null)?.nonce ?? ""
  : "";

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <QueryClientProvider client={getClientsideQueryClient()}>
        <NonceContext.Provider value={clientNonce}>
          <HydratedRouter />
        </NonceContext.Provider>
      </QueryClientProvider>
    </StrictMode>,
    {
      onRecoverableError: (error, info) => {
        console.error("Recoverable hydrateRoot error", error, info);
      },
    },
  );
});
